import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import fonts from "./assets/styles/fonts.scss"
import '@mdi/font/css/materialdesignicons.min.css';
import GlobalComponents from './components/app/globalComponents'
import ru from 'vuetify/lib/locale/ru'
import VueMask from 'v-mask'
import { mapMutations, mapState } from 'vuex'

Vue.use(VueMask)

Vue.config.productionTip = false
Vue.mixin({
  computed:{
    ...mapState('user', ['userInfo']),
  },
  methods: {
    ...mapMutations('user', ['setUserPhone']),
    convertToValueLabel(value) {
      switch (value) {
        case "USD": 
          return "$"
        case "RUR": 
          return "₽"
        case "EUR":
          return "€"
        case "KZT":
          return "₸"
        case "JPY":
          return "¥"
        case "CNY":
          return "¥"
        case "month":
          return "мес."
      }
      return value
    },

    async hijackingPhoneNumber() {
      window.onmessage = (event) => {
        if(event.data.type != 'hash' || !window.location.href.includes('#')) {
          this.deleteHash()
          return
        }
        let phone = window.location.hash.slice(1).replaceAll("%20","")
        phone = phone.replace(/[^0-9]/g,"")
        this.returnLinkCode(phone)
      }

    },

    deleteHash() {
      if (window.location.href.includes('#')) {
        setTimeout(() => {
          this.$router.go(-1)
          setTimeout(() => {
            if(window.location.href.includes('#')) {
              this.$router.go(-1)
            }
          }, 100);
        }, 0);
      }
    },

    returnLinkCode(phone) {
      console.log(phone);
      
      if(phone.length <= 10) phone = "7" + phone

      if(phone.length == 11 && phone[0] == '8') {
        let arr = phone.split('')
        arr[0] = '7'
        phone = arr.join('')
      }
      
      if(phone.length <= 10) {
        phone = "7" + phone
      }

      this.setUserPhone(phone)

      this.deleteHash()
    },

    returnPlatformDevice() {

      let userDeviceArray = [
        {device: 'Android', platform: /Android/},
        {device: 'iPhone', platform: /iPhone/},
      ];
  
      var platform = navigator.userAgent;
  
      for (var i in userDeviceArray) {

        if (userDeviceArray[i].platform.test(platform)) {
          return userDeviceArray[i].device;
        }

      }
  
    },
  }
})

Vue.use(Vuetify)
export default new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru',
  },
})

const tempGlobal = {
  install(Vue) {
    Vue.use(GlobalComponents);
  }
}
Vue.use(tempGlobal)
new Vue({
  router,
  store,
  fonts,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
